interface LoadingState {
    isCityBrowseLoading?: boolean;
    isFeLoading: boolean | undefined;
    isOrganizerArticlesLoading?: boolean | undefined;
    isProfilesLoading?: boolean | undefined;
    isSearchLoading?: boolean | undefined;
}

export const currentLoadingState = (loadingState: LoadingState | undefined) => {
    if (
        loadingState &&
        !loadingState.isFeLoading &&
        !loadingState.isSearchLoading &&
        !loadingState.isCityBrowseLoading
    ) {
        return false;
    } else return true;
};

/****************************** Home Page Featured Seasonal Component ********************************/
export interface HOLIDAY_FEATURED {
    [key: string]: {
        title: string;
        subTitle: string;
        description: string;
        viewMoreUrl: string;
        categoryTag: string[];
        locations: {
            [key: string]: string[];
        };
    };
}

export const SEASONAL_HOLIDAY_FEATURED: HOLIDAY_FEATURED = {
    HALLOWEEN: {
        title: 'GET OUT, GET OUT',
        subTitle: 'WHEREVER YOU ARE',
        description: 'This Halloween, it’s all treats—and a few tricks 🎃',
        viewMoreUrl:
            '/b/local/holiday/halloweenhaunt/?utm_source=halloween-featured',
        categoryTag: ['EventbriteSubCategory/16004'],
        locations: {
            country: ['USA', 'United States'],
            cityIds: ['101750367'], // London location
        },
    },
};

export function isLocationEnable(
    holiday: string,
    country: string | undefined,
    placeId: string | null | undefined,
    currentPlace: string,
) {
    // check if component is enable for the country or city
    if (
        (country &&
            SEASONAL_HOLIDAY_FEATURED[holiday].locations.country.indexOf(
                country,
            ) > -1) ||
        (placeId &&
            SEASONAL_HOLIDAY_FEATURED[holiday].locations.cityIds.indexOf(
                placeId,
            ) > -1) ||
        currentPlace == 'Online'
    )
        return true;

    return false;
}
